import Fallback from './DeviceRegister.fallback';
import { routeEntry } from '../route-utils';

export default routeEntry({
  fallback: <Fallback />,
  component: () => import('./DeviceRegister.page'),
});
